var _path, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTcTokenomicsS2Icon1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 56,
    height: 74,
    viewBox: "0 0 56 74",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.9727 0.5H37.0273C40.003 0.500136 42.8069 1.89478 44.6025 4.26758L53.5752 16.125C54.8239 17.7752 55.5 19.788 55.5 21.8574V52.1426C55.5 54.212 54.824 56.2248 53.5752 57.875L44.6025 69.7324C42.8069 72.1052 40.003 73.4999 37.0273 73.5H18.9727C15.997 73.4999 13.1931 72.1052 11.3975 69.7324L2.4248 57.875C1.17605 56.2248 0.5 54.212 0.5 52.1426V21.8574L0.507812 21.4697C0.586679 19.5375 1.25415 17.672 2.4248 16.125L11.3975 4.26758C13.137 1.9689 15.8229 0.588025 18.6943 0.503906L18.9727 0.5Z",
    fill: "url(#paint0_linear_375_1932)",
    stroke: "#4BFF5E"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_375_1932",
    x1: 28,
    y1: 0,
    x2: 28,
    y2: 74,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4BFF5E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00B313"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTcTokenomicsS2Icon1);
export default __webpack_public_path__ + "static/media/tc_tokenomics_s2_icon1.ebfe93d52174b70424816336d3d27dd0.svg";
export { ForwardRef as ReactComponent };